import { useSettingsStore } from '../store'
import { HourConfigField } from './HourConfigField'

export function KycHoursTab() {
  const { hourSettings, updateKycHours } = useSettingsStore()
  const kyc = hourSettings.kyc

  return (
    <div className="space-y-6">
      {/* Base Setup */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Base Setup</h4>
        <HourConfigField
          label="KYC Base Setup"
          value={kyc.baseSetup}
          onChange={(v) => updateKycHours('baseSetup', v)}
          description="Initial configuration and account setup"
        />
      </div>

      {/* AU Document Types */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Australian Document Types</h4>
        <HourConfigField
          label="Passport"
          value={kyc.auDocumentPassport}
          onChange={(v) => updateKycHours('auDocumentPassport', v)}
        />
        <HourConfigField
          label="Driver's License"
          value={kyc.auDocumentDriversLicense}
          onChange={(v) => updateKycHours('auDocumentDriversLicense', v)}
        />
        <HourConfigField
          label="Medicare Card"
          value={kyc.auDocumentMedicare}
          onChange={(v) => updateKycHours('auDocumentMedicare', v)}
        />
        <HourConfigField
          label="Foreign Passport (Visa)"
          value={kyc.auDocumentForeignPassport}
          onChange={(v) => updateKycHours('auDocumentForeignPassport', v)}
        />
        <HourConfigField
          label="Birth Certificate"
          value={kyc.auDocumentBirthCertificate}
          onChange={(v) => updateKycHours('auDocumentBirthCertificate', v)}
        />
        <HourConfigField
          label="Proof of Age Card"
          value={kyc.auDocumentProofOfAge}
          onChange={(v) => updateKycHours('auDocumentProofOfAge', v)}
        />
      </div>

      {/* NZ Document Types */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">New Zealand Document Types</h4>
        <HourConfigField
          label="Passport"
          value={kyc.nzDocumentPassport}
          onChange={(v) => updateKycHours('nzDocumentPassport', v)}
        />
        <HourConfigField
          label="Driver's License"
          value={kyc.nzDocumentDriversLicense}
          onChange={(v) => updateKycHours('nzDocumentDriversLicense', v)}
        />
        <HourConfigField
          label="Birth Certificate"
          value={kyc.nzDocumentBirthCertificate}
          onChange={(v) => updateKycHours('nzDocumentBirthCertificate', v)}
        />
      </div>

      {/* Additional Features */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Additional Features</h4>
        <HourConfigField
          label="Consent Sources Setup"
          value={kyc.consentSources}
          onChange={(v) => updateKycHours('consentSources', v)}
          description="Enable consent source configuration"
        />
        <HourConfigField
          label="DVS Setup"
          value={kyc.dvsSetup}
          onChange={(v) => updateKycHours('dvsSetup', v)}
          description="Document Verification Service integration"
        />
        <HourConfigField
          label="VEVO Integration"
          value={kyc.vevoIntegration}
          onChange={(v) => updateKycHours('vevoIntegration', v)}
          description="Visa Entitlement Verification Online"
        />
        <HourConfigField
          label="International KYC (per country)"
          value={kyc.internationalKycPerCountry}
          onChange={(v) => updateKycHours('internationalKycPerCountry', v)}
          description="Hours per additional international country"
        />
        <HourConfigField
          label="Custom Ruleset"
          value={kyc.customRuleset}
          onChange={(v) => updateKycHours('customRuleset', v)}
          description="Custom verification ruleset configuration"
        />
        <HourConfigField
          label="Vendor Integration"
          value={kyc.vendorIntegration}
          onChange={(v) => updateKycHours('vendorIntegration', v)}
          description="Non-FrankieOne vendor setup"
        />
      </div>

      {/* Advanced Configuration */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Advanced Configuration</h4>
        <HourConfigField
          label="Per Additional Ruleset"
          value={kyc.perAdditionalRuleset}
          onChange={(v) => updateKycHours('perAdditionalRuleset', v)}
          description="Hours per additional KYC ruleset beyond the first"
        />
        <HourConfigField
          label="Manual Review Setup"
          value={kyc.manualReviewSetup}
          onChange={(v) => updateKycHours('manualReviewSetup', v)}
          description="Manual review trigger configuration"
        />
        <HourConfigField
          label="Cascade Setup"
          value={kyc.cascadeSetup}
          onChange={(v) => updateKycHours('cascadeSetup', v)}
          description="Data source cascade strategy configuration"
        />
        <HourConfigField
          label="Per Data Source"
          value={kyc.perDataSource}
          onChange={(v) => updateKycHours('perDataSource', v)}
          description="Hours per selected data source"
        />
        <HourConfigField
          label="Aging Setup"
          value={kyc.agingSetup}
          onChange={(v) => updateKycHours('agingSetup', v)}
          description="KYC aging/re-verification configuration"
        />
      </div>
    </div>
  )
}
